export default "__VITE_ASSET__CeAq6I9F__"